/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const CONFIG = "CONFIG";
export const SET_LIST = "SET_LIST";
export const CACHE_LIST = "CACHE_LIST";
export const SET_PULLING_STATE = "SET_PULLING_STATE";
export const SET_PROMISE = "SET_PROMISE";
export const ROUTE_HISTORY = "ROUTE_HISTORY";
export const LABEL_STATUS = "LABEL_STATUS";
export const LABEL_DATA = "LABEL_DATA";
export const FRESH_LOCATION_LIST = "FRESH_LOCATION_LIST";
export const SET_LOCALE = "SET_LOCALE";

export default {
    CONFIG,
    SET_LIST,
    CACHE_LIST,
    SET_PULLING_STATE,
    SET_PROMISE,
    ROUTE_HISTORY,
    LABEL_STATUS,
    LABEL_DATA,
    FRESH_LOCATION_LIST,
    SET_LOCALE
};